// extracted by mini-css-extract-plugin
module.exports = {"blocker":"ArticleBarrier_blocker__1iNSe"};